import { createFilePath } from "@/common";
import { useWatchState } from "@/store";
import React from "react";
import logoPng from "../../assets/images/logo-cloud-text-hight.png";
import Bg from "./images/Bg.jpg";
import Bg3 from "./images/Bg3.jpg";
import chengguo_download from "../../assets/images/chengguo_download.jpg";
import "./style.less";
import { Modal } from 'antd';

let url = 'http://ww2.techchina.org.cn/?wst=';
//let urlNew = 'http://www.tianhe-cloud.com/?region=';
let urlNew = 'http://www.tianhe-cloud.com/?region=';
//let url='http://localhost:3000/?region=';
let sz = '6797ace0-deae-11e9-909b-5590d191b375&regions=130128&levels=3#/';
let gy = '36736dc0-f35b-11eb-b8a3-63deceb5a893&regions=130127&levels=3#/';
let zx = '7006eb80-39ce-11eb-aa3f-012bb2bcbb08&regions=130133&levels=3#/';
let ysx = '9ff51b30-fee4-11e9-9366-ef370f46f71e&regions=130132&levels=3#/';
let lq = '3570c040-39ce-11eb-aa3f-012bb2bcbb08&regions=130185&levels=3#/';
let sjz = 'http://www.tianhe-cloud.com/?region=130100';
let jxkq = 'fSk4XragC53qLKD4bL4As7vfwj9mK7hk&regions=130107&levels=3#/';
let gcs = '5b03bd30-39ce-11eb-aa3f-012bb2bcbb08&regions=130182&levels=3#/';
let jxx = '526b9d90-f35b-11eb-b8a3-63deceb5a893&regions=130121&levels=3#/';
let xls = 'uH9OpeVqvXUuK5JO9wCQUrwOO1O3PIX9&regions=130184&levels=3#/';
let jzs = '5e333200-deae-11e9-909b-5590d191b375&regions=130183&levels=3#/';
let wj = 'e51016907e0011ed8b789bc89a6dfdb9&regions=130130&levels=3#/';
let xt = '5ae721707e0011ed8667d1c4011db1e3&regions=130125&levels=3#/';
let ps = '0d77b7507e0111ed8667d1c4011db1e3&regions=130131&levels=3#/';
let lc = 'b5d5c5b0651111efb5b7cbdce7aa4f02&regions=130124&levels=3#/';
let zd = '79a4af20651111efb5b7cbdce7aa4f02&regions=130123&levels=3#/';
let zh = '6c3733000c1811ef98d261a5c3414e34&regions=130129&levels=3#/';
let ls = '4d6a86700c1811ef98d261a5c3414e34&regions=130126&levels=3#/';

class Modal_Btn extends React.Component {
    state = {
        modal2Visible: false,
        modal3Visible: false,
    };

    setModal2Visible(modal2Visible) {
        this.setState({ modal2Visible });
    }
    setModal3Visible(modal3Visible) {
        this.setState({ modal3Visible });
    }

    render() {
        return (
            <div style={{ display: "flex" ,marginTop:"-13px" }}>
                <button className="right_button" style={{ width: 150}} onClick={() => this.setModal2Visible(true)}><span>区县工作站</span></button><button className="right_button" style={{ width: 300, marginLeft: 20, marginRight: 200 }} onClick={() => this.setModal3Visible(true)}><span>区县数字科创精准服务平台</span></button>
                <Modal
                    title="石家庄区县工作站"
                    width={1024}
                    centered
                    visible={this.state.modal2Visible}
                    onOk={() => this.setModal2Visible(false)}
                    onCancel={() => this.setModal2Visible(false)}
                    footer={false}
                    className={'modal-Bg'}
                >
                    <div class="box">

                        <img src={Bg} alt="" usemap="#planetmap" />

                        <map name="planetmap" id="planetmap">
                            <area shape="rect" coords="265,510,402,614" href={url + sz} target="_blank" alt="深泽县"
                                id="mapArea1" />
                            <area shape="rect" coords="510,10,652,113" href={url + gy} target="_blank" alt="高邑县"
                                id="mapArea2" />
                            <area shape="rect" coords="697,17,847,119" href={url + zx} target="_blank" alt="赵县"
                                id="mapArea3" />
                            <area shape="rect" coords="862,69,1006,171" href={url + ysx} target="_blank" alt="元氏县"
                                id="mapArea4" />
                            <area shape="rect" coords="4,304,101,457" href={url + lq} target="_blank" alt="鹿泉县"
                                id="mapArea5" />
                            <area shape="rect" coords="364,250,576,376" href={sjz} target="_blank" alt="石家庄"
                                id="mapArea6" />
                            <area shape="rect" coords="871,187,1020,292" href={url + jxkq} target="_blank" alt="井陉矿区"
                                id="mapArea7" />
                            <area shape="rect" coords="4,479,104,613" href={url + gcs} target="_blank" alt="蒿城市"
                                id="mapArea8" />
                            <area shape="rect" coords="125,476,229,615" href={url + jxx} target="_blank" alt="井陉县"
                                id="mapArea9" />
                            <area shape="rect" coords="584,508,730,609" href={url + xls} target="_blank" alt="新乐市"
                                id="mapArea10" />
                            <area shape="rect" coords="912,465,988,609" href={url + jzs} target="_blank" alt="晋州市"
                                id="mapArea11" />
                            <area shape="rect" coords="10,13,145,127" href={url + wj} target="_blank" alt="无极县"
                                id="mapArea12" />
                            <area shape="rect" coords="172,13,307,127" href={url + xt} target="_blank" alt="行唐县"
                                id="mapArea13" />
                            <area shape="rect" coords="765,494,884,610" href={url + ps} target="_blank" alt="平山县"
                                id="mapArea14" />
                            <area shape="rect" coords="442,520,556,616" href={url + lc} target="_blank" alt="栾城区"
                                id="mapArea15" />
                            <area shape="rect" coords="356,10,467,112" href={url + zd} target="_blank" alt="正定县"
                                id="mapArea16" />
                            <area shape="rect" coords="5,149,168,286" href={url + zh} target="_blank" alt="赞皇县"
                                id="mapArea17" />
                            <area shape="rect" coords="866,309,1007,452" href={url + ls} target="_blank" alt="灵寿县"
                                id="mapArea18" />
                        </map>
                    </div>
                </Modal>
                <Modal
                    title="区县数字科创精准服务平台"
                    width={1024}
                    centered
                    visible={this.state.modal3Visible}
                    onOk={() => this.setModal3Visible(false)}
                    onCancel={() => this.setModal3Visible(false)}
                    footer={false}
                    className={'modal-Bg'}
                >
                    <div class="box">

                        <img src={Bg3} alt="" usemap="#planetmap" />

                        <map name="planetmap" id="planetmap">
                            <area shape="rect" coords="265,510,402,614" href={urlNew + 130128} target="_blank" alt="深泽县"
                                id="mapArea1" />
                            <area shape="rect" coords="510,10,652,113" href={urlNew + 130127} target="_blank" alt="高邑县"
                                id="mapArea2" />
                            <area shape="rect" coords="697,17,847,119" href={urlNew + 130133} target="_blank" alt="赵县"
                                id="mapArea3" />
                            <area shape="rect" coords="862,69,1006,171" href={urlNew + 130132} target="_blank" alt="元氏县"
                                id="mapArea4" />
                            <area shape="rect" coords="4,304,101,457" href={urlNew + 130185} target="_blank" alt="鹿泉县"
                                id="mapArea5" />
                            <area shape="rect" coords="364,250,576,376" href={urlNew + 130100} target="_blank" alt="石家庄"
                                id="mapArea6" />
                            <area shape="rect" coords="871,187,1020,292" href={urlNew + 130107} target="_blank" alt="井陉矿区"
                                id="mapArea7" />
                            <area shape="rect" coords="4,479,104,613" href={urlNew + 130182} target="_blank" alt="蒿城市"
                                id="mapArea8" />
                            <area shape="rect" coords="125,476,229,615" href={urlNew + 130121} target="_blank" alt="井陉县"
                                id="mapArea9" />
                            <area shape="rect" coords="584,508,730,609" href={urlNew + 130184} target="_blank" alt="新乐市"
                                id="mapArea10" />
                            <area shape="rect" coords="912,465,988,609" href={urlNew + 130183} target="_blank" alt="晋州市"
                                id="mapArea11" />
                            <area shape="rect" coords="10,13,145,127" href={urlNew + 130130} target="_blank" alt="无极县"
                                id="mapArea12" />
                            <area shape="rect" coords="172,13,307,127" href={urlNew + 130125} target="_blank" alt="行唐县"
                                id="mapArea13" />
                            <area shape="rect" coords="765,494,884,610" href={urlNew + 130131} target="_blank" alt="平山县"
                                id="mapArea14" />
                            <area shape="rect" coords="442,520,556,616" href={urlNew + 130124} target="_blank" alt="栾城区"
                                id="mapArea15" />
                            <area shape="rect" coords="356,10,467,112" href={urlNew + 130123} target="_blank" alt="正定县"
                                id="mapArea16" />
                            <area shape="rect" coords="5,149,168,286" href={urlNew + 130129} target="_blank" alt="赞皇县"
                                id="mapArea17" />
                            <area shape="rect" coords="866,309,1007,452" href={urlNew + 130126} target="_blank" alt="灵寿县"
                                id="mapArea18" />
                        </map>
                    </div>
                </Modal>
            </div>
        );
    }
}

function Logo({ logo = logoPng, title, className = "", style = {}, theme = 'hight', showDesc = true }) {

    const [[REGION = {}]] = useWatchState(["$_REGION"])
    const [[UPLOAD_SERVER_HOST = ""]] = useWatchState(["$_UPLOAD_SERVER_HOST"]);
    const [[IS_REGION]] = useWatchState(["IS_REGION"]);

   //const _title = title || ((IS_REGION ? REGION.name : "天合") + "科技成果转化服务广场")
   const _title = title || ((IS_REGION ? REGION.name : "天合") + "数字科创精准服务平台")
    return (
        <div className="flex">
            <div className={`com-logo com-logo--${theme} flex ver child-left-sm ${className}`} style={style}>
                <img className="com-logo__img" src={IS_REGION ? createFilePath(REGION.logo, UPLOAD_SERVER_HOST) : logo} />
                {IS_REGION && <div className="com-logo__content">
                    {/*<h3 className={`${theme}-title font-size-20`} style={{ margin: "0" }}>{_title}</h3>*/}
                    <h3 className={`${theme}-title font-size-20`} style={{ margin: "0" }}>{_title}</h3>
                    {showDesc && <p className="font-size-12" style={{ margin: "0" }}>{IS_REGION ? REGION.en_name : "tianhe"} digital science and technology innovation precision service platform</p>}
                </div>}
            </div>
            <div className="top_width">
                <div className="top_right">{(REGION.name === '石家庄') ?
                    <div className="top_right_button">
                        <Modal_Btn />
                    </div> : <div></div>}
                    {(REGION.name === '新乐市' || REGION.name === '深泽县' || REGION.name === '井陉县' || REGION.name === '井陉矿区' || REGION.name === '高邑县' || REGION.name === '元氏县' || REGION.name === '赵县' || REGION.name === '藁城市' || REGION.name === '晋州市' || REGION.name === '鹿泉市' || REGION.name === '无极县' || REGION.name === '行唐县' || REGION.name === '平山县'|| REGION.name === '栾城区'|| REGION.name === '正定县'|| REGION.name === '灵寿县'|| REGION.name === '赞皇县') ?
                        <div className="top_right_button" style={{marginTop:"17px" }}>
                            <button className="right_button"><span><a href={sjz} style={{ color: '#fff'}}>石家庄科转中心</a></span></button>
                        </div> : <div></div>}
                </div>
            </div>

        </div>
    )
}

export default Logo;